<template>
  <b-row class="article" no-gutters>
    <b-col lg="3" md="12">
      <div
        class="thumbnail"
        v-bind:style="{ 'background-image': 'url(' + '//'+this.url+ this.download_url + ')' }"
      />
    </b-col>
    <b-col lg="9" md="12" class="content d-flex flex-column align-items-start">
      <h4>{{this.article_data.display_title}}</h4>
      <div class="details d-flex justify-content-between flex-wrap">
        <div class="date">{{this.article_data.date}}</div>
        <ul class="tag-list">
          <li v-for="(project, index) in this.article_data.associated_projects" :key="index">
            <router-link :to="'/projects/' + project.project_path" tag="a">{{project.project_name}}</router-link>
          </li>
          <li v-for="(member, index) in this.article_data.associated_members" :key="index">
            <router-link :to="'/members/' + member.id" tag="a">{{member.name}}</router-link>
          </li>
        </ul>
      </div>

      <p class="text-break" v-html="this.article_data.summary"></p>
      <router-link class="mt-auto" :to="this.article_path">
        <b-button variant="primary">Read More</b-button>
      </router-link>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: "Piece",
  props: ["article_data"],
  data() {
    return {
      download_url: this.article_data.image.download_url,
      title: this.article_data.image.title,
      article_path: `/news/${this.article_data.id}`,
      url: ''
    };
  },
  created() {
    this.url = process.env.VUE_APP_API_URL
  }
};
</script>

<style lang="scss">
.article {
  .content {
    padding-left: 2em !important;
    p {
      font-size: 1.05em;
      margin: 0;
    }
    @include media-breakpoint-down(md) {
      padding: 2em 0 0 0 !important;
      button {
        margin-top: 1em;
      }
    }
  }
  .details {
    margin-bottom: 0.5em;
    width: 100%;
    font-size: 1.1em;
    text-transform: uppercase;
    
    .tag-list {
      padding-left: 0;
      margin: 0;
      font-size: 0.9em;
      li {
        display: inline;
        text-transform: uppercase;
        * {
          color: $secondary-color !important;
        }
        &:not(:last-child):after {
          content: ", ";
        }
      }
    }
  }
  a {
    color: $secondary-color !important;
    &:hover {
      color: $secondary-color !important;
    }
    cursor: pointer;
  }
  .thumbnail {
    width: 100% !important;
    padding-bottom: 70% !important;
    background-size: cover !important;
    background-position: center !important;
  }
}
</style>